import { FC, Card, useState, useMemo }  from 'external/react'

import SelectUserModal from 'pages/home/packages/dialogs/SelectUserModal'

import usePackage from 'context/package-context/hook'
import SavePackageButton from './SavePackageButton'
import { Package, PackageUser } from 'types/context/package'

import PlanInfo from 'components/PlanInfo'
import CourseList from 'components/CourseList'
import SelectTutor from 'components/SelectTutor'
import SelectStudent from 'components/SelectStudent'
import { isUUID } from 'external/lodash'

const PackagePage: FC =  () => {

	const {update, state: {packageItem}, selectedStudent, selectedTutor} = usePackage()
	
	const [clean, updateClean] = useState(true) 

    const saveDisabled = useMemo(() => clean || !(isUUID(selectedStudent?.id) && isUUID(selectedTutor?.id)), [selectedStudent, selectedTutor, clean])

	async function handleUserSelection (role: string, selectedUser: PackageUser | null, purchase: Package) {
		if (selectedUser !== null) {
			const updateUser = {
				[role.toLowerCase()]: selectedUser,
			}
			update({packageItem: {data: {$shallow: updateUser}}})
		}
	}

	return (
        <Card.Body className='d-flex flex-column'>
			<SelectUserModal onSelectUser={handleUserSelection} role='Student' />
			<SelectUserModal onSelectUser={handleUserSelection} role='Tutor' />
			<PlanInfo packageItem={packageItem.data} />
			<div className='d-flex mt-3 gap-3'>
				<SelectStudent packageItem={packageItem.data} update={update} changed={() => updateClean(false)}/>
				<SelectTutor packageItem={packageItem.data} update={update} changed={() => updateClean(false)}/>
			</div>
			<CourseList courses={packageItem.courses.basic || []} source='basic' />
			<CourseList courses={packageItem.courses.elective || []} source='elective' />
			<div className='flex-grow-1' />
			<div className='mt-3'>
				<div className='col-md-12'>
					<SavePackageButton saveDisabled={saveDisabled} />
				</div>
			</div>
		</Card.Body>
	)
}


export {PackagePage as default}